import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	center: {
		maxWidth: "315px",
		textAlign: "center"
	},
	img: {
		width: "100%"
	},
	button: {
		marginTop: "25px"
	},contentFilter: {
		paddingTop: theme.spacing.unit * 2,
	},
	contentSelectAll: {
		opacity: 0.5,
		padding: '2px 4px 2px 0',
		marginTop : - theme.spacing.unit * 2,
        '& svg': {
            fontSize: '1.5rem'
        }
	},
	paddingLeft: {
		paddingLeft: theme.spacing.unit * 2
	},
	textRight: {
		textAlign: 'right',
	},
	inlineBlock: {
		display: 'inline-block'
	}
});
